import React from 'react'

import styles from  './index.module.css'

const Container = ({ customCSS, ...restProps }) => (
  <div
    className={`${styles.container} ${customCSS}`}
    {...restProps}
  >
    <span className={styles.spanElement}>This is the span</span>

    <p className={styles.pElement}>This is the paragraph <span className={styles.secondSpan}>and this is the span inside the paragraph</span></p>
  </div>
)

export default Container